import { http } from './http';
import { checkOrCreateBookByDate } from './book';


export async function listOrders(params = {}) {
    const { data } = await http.get('book/orders/', { params });
    return data;
}


export async function getOrder(id) {
    const { data } = await http.get(`book/orders/${id}/`);
    return data;
}


export async function createOrder(payload) {
    
    const { data } = await http.post('book/orders/', payload);
    return data;
}


export async function updateOrder(id, payload) {
    const { data } = await http.patch(`book/orders/${id}/`, payload);
    return data;
}


export async function deleteOrder(id) {
    const { data } = await http.delete(`book/orders/${id}/`);
    return data;
}

// Получить приказ из контекста Book через book/check/
export async function getBookOrderFromContext(dateISO) {
    const ctx = await checkOrCreateBookByDate(dateISO || new Date().toISOString().slice(0,10));
    const node = Array.isArray(ctx) ? ctx[0] : ctx;
    return node?.order || null;
}
